import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ScheduleService {
  constructor(private http: HttpClient) {}

  getDoctorSchedule(doctorId: number, unixTime: number): Observable<any> {
    return this.http.get(
      `api/Schedule/GetDoctorSchedule?doctorId=${doctorId}&date=${unixTime}`
    );
  }
}
